import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { Geometry } from 'geojson';

import { RelatedEntitiesListComponent } from '@connect-services/client/components/entity-detail-template/related-entities-list/related-entities-list.component';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { LayerRelation } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ExpansionPanelComponent, RelatedEntitiesListComponent, RessourcesModule],
    selector: 'app-related-layer-list',
    templateUrl: './related-layer-list.component.html',
})
export class RelatedLayerListComponent {
    public readonly layerRelations = input.required<LayerRelation[]>();
    public readonly sourceEntityId = input.required<string>();
    public readonly sourceGeometry = input<Geometry | null>(null);
    public readonly sourceLayerId = input.required<string>();
    public readonly sourceTableName = input.required<string>();

    protected readonly hasBeenExpanded = signal<boolean>(false);

    protected toggleExpanded(): void {
        if (this.hasBeenExpanded()) {
            return;
        }

        this.hasBeenExpanded.set(true);
    }
}
